module.exports = __webpack_public_path__ + "static/media/Get Catering Orders.eaa7f14e.png";